import React, { PureComponent } from 'react';

import { Wrapper } from './styles';

export default class Container extends PureComponent {
    render() {
        const { long, children } = this.props;
        return <Wrapper long={long}>{children}</Wrapper>;
    }
}
